export function parseCurrency(amount: number | undefined): string {
    return amount === undefined ?
        '' :
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(amount);
}